import { render, staticRenderFns } from "./AddDepartmentModal.vue?vue&type=template&id=7cb46754&scoped=true&"
import script from "./AddDepartmentModal.vue?vue&type=script&lang=js&"
export * from "./AddDepartmentModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDepartmentModal.vue?vue&type=style&index=0&id=7cb46754&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb46754",
  null
  
)

export default component.exports